import DynamicImage from "@ds/components/DynamicImage";
import { CloseIcon } from "@icons/index";
import { Backdrop, Box, Link } from "@mui/material";
import useStyles from "./styles";

interface IBackdropImage {
  isOpen: boolean;
  src: string;
  alt: string;
  isMobile: boolean;
  width: number;
  height: number;
  onCloseZoomImage: () => void;
}

const ZoomImage = ({
  isOpen,
  onCloseZoomImage,
  isMobile,
  src,
  alt,
  width,
  height,
}: IBackdropImage) => {
  const classes = useStyles();
  return (
    <Backdrop
      data-testid="backdrop-click"
      sx={{
        color: "rgba(46, 67, 77, 0.4)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isOpen}
      onClick={onCloseZoomImage}
    >
      <Box sx={{ position: "relative" }} mx={isMobile ? "24px" : "auto"}>
        <Link className={classes.imageCloseBtn} onClick={onCloseZoomImage}>
          <CloseIcon className={classes.closeIcon} />
        </Link>
        <DynamicImage
          src={src}
          alt={alt}
          width={width}
          height={height}
          position="relative"
          rounded
        />
      </Box>
    </Backdrop>
  );
};

export default ZoomImage;
